import React from 'react';
import PropTypes from 'prop-types';
import {Form, Select, LocaleProvider, message, Icon, Button} from 'antd';
import ui from '../../lang/ui.json';
import s from './ContactSearch.css';
import {fetchDecode} from '../../fetchUtils';
import {isValidPhoneNumber, isInvalidPhoneNumber} from "../../phoneNumberUtils";
import locale from '../../lang/locale.json';
import * as XLSX from "xlsx";
import Dropzone from "react-dropzone";

class ContactSearch extends React.Component {
    static propTypes = {
        onSubmit: PropTypes.func,
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            contacts: [],
            search: [],
            filterDropdownVisible: false,
            searchText: '',
            filtered: false,
            multiple: [],
            validation: true,
            config: require('Config'),
            locale: locale["ContactSearch"],
            files: [],
            invalidNumbers: []
        };
        this.submitSearch = this.submitSearch.bind(this);
    }

    componentDidMount() {
        fetchDecode(this.state.config.serverUrl + `contacts/all`, message)
            .then(response => this.setState({contacts: response}));
    }

    checkValidation() {
        const rule = !!this.state.multiple.toString();
        this.setState({validation: rule});
        return rule;
    }

    updateValidation(value) {
        var strip = value;
        strip = value.map(el => el.replace(/-/g, ''));
        var invalidNumbers = strip.filter(number => (!isValidPhoneNumber(number)));
        strip = strip.filter(number => (isValidPhoneNumber(number)));
        this.setState({
            multiple: strip,
            validation: value.toString(),
        });
        var allInvalidNumbers = this.state.invalidNumbers.concat(invalidNumbers);
        this.setState({invalidNumbers: allInvalidNumbers});
    }

    successMessage = () => {
        message.success(this.state.locale.messageSuccess, 2);
    };

    errorMessage = (error) => {
        message.error(`${this.state.locale.messageError} ${error}`, 5);
    };

    submitSearch = (e) => {
        e.preventDefault();
        let numbersToSendTo = this.state.multiple.concat([].concat.apply([], this.state.files.map(x => x.numbers)))
        numbersToSendTo = [...new Set(numbersToSendTo)];
        this.state.multiple = [];
        this.state.files = [];
        this.props.onSubmit(numbersToSendTo);

    };

    handleDrop = (files) => {
        let lines = [];
        let validNumbers = [];
        let invalidNumbers = [];
        files.forEach(file => {
            const reader = new FileReader();
            reader.onload = (evt) => {
                let extension = file.name.split('.').pop();
                if (extension === "xlsx") {
                    const bstr = evt.target.result;
                    const wb = XLSX.read(bstr, {type: 'binary'});
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    const data = XLSX.utils.sheet_to_csv(ws, {header: 1});
                    lines = data.replace(/\s+/g,'\n').replace(/,/g, '\n').split("\n").map(el => el.replace(/-/g, ''));
                }
                else if (extension === "txt") {
                    const fileAsBinaryString = reader.result;
                    lines = fileAsBinaryString.replace(/\s+/g,'\r\n').replace(/,/g, '\r\n').split("\r\n").map(el => el.replace(/-/g, ''));
                }
                validNumbers = lines.filter(isValidPhoneNumber);
                invalidNumbers = lines.filter(isInvalidPhoneNumber).filter(function (el) {return el != ""}); //also remove empty strings
                if (!this.state.files.some(x => x.name == file.name) && validNumbers.length > 0) {
                    this.state.files.push({name: file.name, numbers: validNumbers});
                    this.setState({files: this.state.files});
                }
                this.setState({invalidNumbers: invalidNumbers});
            };
            reader.readAsBinaryString(file);
        });
    }

    removeFile = (event) => {
        let files = this.state.files.filter(x => x.name != event.target.id);
        this.setState({files: files});
    }

    render() {
        const Option = Select.Option;
        return (
            <LocaleProvider locale={ui}>
                <div className={s.root}>
                    <Form onSubmit={this.submitSearch} className={s.form}>
                        <Dropzone activeClassName={s.dropZone} onDrop={this.handleDrop.bind(this)}
                                  style={{width: "100%"}}
                                  disableClick>
                            <Form.Item
                                validateStatus={this.state.validation ? 'success' : 'error'}
                                help={this.state.validation ? '' : this.state.locale.multipleValidation}
                            >

                                <span className={s.name}>{this.state.locale.multipleLabel}</span>
                                <Select
                                    mode="tags"
                                    style={{width: '100%'}}
                                    size="default"
                                    tokenSeparators={[',', '.', ';', ' ']}
                                    name="number"
                                    placeholder={this.state.locale.multiplePlaceholder}
                                    className={s.sms_select}
                                    dropdownClassName={s.sms_select_dropdown}
                                    value={this.state.multiple}
                                    onChange={(event) => {
                                        this.updateValidation(event);
                                    }}
                                >
                                    {this.state.contacts.map(
                                        d => <Option key={d.msisdn}
                                                     value={d.msisdn}>{`${d.msisdn} - ${d.name}`}</Option>,
                                    )}
                                </Select>
                                <ul className={s.fileList}>
                                    {this.state.files.map(file =>
                                            <li>
                                    <span id={file.name} className={s.file}>
                                        {file.name} - {file.numbers.length} {this.state.locale.numberLabel}
                                        <Button id={file.name} type="link" onClick={(e) => this.removeFile(e)}><Icon type="close" className={s.removeIcon} /></Button>
                                    </span>
                                            </li>
                                    )}
                                </ul>

                            </Form.Item>
                        </Dropzone>
                        <div>
                            {this.state.invalidNumbers.length != 0 &&
                            <div className={s.invalidNumbersContainer}>
                                <p className={s.invalidNumbersTitle}>{this.state.locale.invalidNumbers}:</p>
                                <div className={s.invalidNumbersArea}>
                                    {this.state.invalidNumbers.map(invalidNumber =>
                                        <div>
                                            {invalidNumber}
                                        </div>
                                    )}
                                </div>
                            </div>
                            }
                        </div>
                        <div className={s.button_wrapper}>
                            <button className={s.btn_primary}>{this.state.locale.buttonSend}</button>
                        </div>
                    </Form>
                </div>
            </LocaleProvider>
        );
    }
}

export default (ContactSearch);




// WEBPACK FOOTER //
// ./src/routes/contacts/ContactSearch.js